import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from "./locales/en/translation.json";
import heTranslation from "./locales/he/translation.json";
import heTranslationWOW from "./locales/he/translationWOW.json";
import heTranslationLeumit from "./locales/he/translationLeumit.json";

// Initialize i18n with default resources
const defaultResources = {
  en: {
    translation: enTranslation,
  },
  he: {
    translation: heTranslation,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: defaultResources,
    lng: "he", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    fallbackLng: "he",
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

// Function to update translations based on partner type
export const updateTranslationsForPartner = (isMehudet, isLeumit) => {
  const heTranslationToUse = isLeumit ? heTranslationLeumit : isMehudet ? heTranslationWOW : heTranslation;

  // Remove existing resource bundle first, then add the new one
  i18n.removeResourceBundle("he", "translation");
  i18n.addResourceBundle("he", "translation", heTranslationToUse, true, true);
  
  // Force reload the current language to apply changes immediately
  i18n.reloadResources("he", "translation").then(() => {
    i18n.changeLanguage("he");
  });
};

export default i18n;
